module.exports = __webpack_public_path__ + "static/amrel-f9571745d239d4773e1e5ac93c177b67.png";